// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1JBbD","content":"GlobalSearch_content__3e25X"};